/* eslint-disable jsx-a11y/label-has-associated-control */
import type { VoidFunctionComponent } from 'react';

import Toggle from '../../../../../../../generic/Toggle';
import styles from './ShowOnlyAddedProjectsToggle.module.less';
import Flex from '../../../../../../../generic/Flex';

type Props = {
  isChecked: boolean;
  onToggle: (isChecked: boolean) => void;
};

const ShowOnlyAddedProjectsToggle: VoidFunctionComponent<Props> = ({ isChecked, onToggle }) => (
  <Flex gap={8} justify="flex-end">
    <Toggle
      id="showOnlyAddedProjectsToggle"
      checked={isChecked}
      onChange={onToggle}
    />
    <label
      className={styles.label}
      htmlFor="showOnlyAddedProjectsToggle"
    >
      Show only added projects
    </label>
  </Flex>
);

export default ShowOnlyAddedProjectsToggle;
